import Component from "@glimmer/component";
import colors, { type Color } from "glesys-controlpanel/helpers/colors";

export interface PillSignature {
  Args: {
    text?: string;
    color?: Color;
    uppercase?: boolean;
    size?: "small" | "default";
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class Pill extends Component<PillSignature> {
  get text() {
    return this.args.text || null;
  }

  get color() {
    return this.args.color || "gray";
  }

  get uppercase() {
    return this.args.uppercase ?? true;
  }

  get sizeClasses() {
    return this.args.size === "small" ? "text-2xs px-2 py-0.5" : "text-xs px-3 py-1";
  }

  <template>
    <div ...attributes>
      <span
        class="inline-flex items-center
          {{this.sizeClasses}}
          font-bold
          {{if this.uppercase 'uppercase'}}
          tracking-wide rounded-full
          {{colors this.color}}"
      >
        {{yield}}
        {{this.text}}
      </span>
    </div>
  </template>
}
